import gql from 'graphql-tag';

export const AREAS_OF_MINISTRY = gql`
  query AreasOfMinistry {
    areaOfMinistries {
      id
      key
      label
    }
  }
`;

export const SIGNUP = gql`
  mutation Signup($input: SignupInput!) {
    signup(input: $input) {
      organization {
        id
        name
        website
        timezone
        address
        addressTwo
        city
        state
        zip
        country
        slug
      }
      errors {
        code
        message
        property
      }
    }
  }
`;
